import React, { useEffect } from 'react';

const PrivacyPolicyRedirectPage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace('/privacy-policy');
    }
  }, []);

  return (
    <main style={{ minHeight: '60vh', padding: '96px 24px', background: '#030405', color: '#fff' }}>
      <h1>Redirecting to privacy policy...</h1>
      <p>
        If you are not redirected automatically, visit{' '}
        <a href="/privacy-policy" style={{ color: '#ff5c18' }}>
          /privacy-policy
        </a>.
      </p>
    </main>
  );
};

export default PrivacyPolicyRedirectPage;
